import { createRoute, useParams } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { ProgramDetailView } from "@/features/academy/components/programs-view";

function AcademyProgramDetailPage() {
  const params = useParams({ from: "/u/$u/academy/programs/$programId" });
  return <ProgramDetailView programId={params().programId} />;
}

export const academyProgramDetailRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/academy/programs/$programId",
  component: AcademyProgramDetailPage,
});
